import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { ChallengeActivityService } from '@examdojo/challenge';
import { ErrorHandlerService } from '@examdojo/core/error-handling';
import { HomeworkActivityService } from '@examdojo/homework';
import { PracticeActivityService } from '@examdojo/practice-activity';
import { mapToVoid } from '@examdojo/rxjs';
import { catchError, EMPTY, first, of, switchMap } from 'rxjs';
import { ActivityService } from './activity.service';

export const activityResolver: ResolveFn<void> = () => {
  const activityService = inject(ActivityService);
  const challengeActivityService = inject(ChallengeActivityService);
  const practiceActivityService = inject(PracticeActivityService);
  const homeworkActivityService = inject(HomeworkActivityService);
  const errorHandler = inject(ErrorHandlerService);

  return activityService.fetchUserActivity().pipe(
    switchMap((activity) => {
      if (!activity) {
        return of(null);
      }

      const { practice_activity_id, challenge_activity_id, homework_activity_id } = activity;

      if (practice_activity_id) {
        return practiceActivityService.fetch(practice_activity_id);
      }
      if (challenge_activity_id) {
        return challengeActivityService.fetch(challenge_activity_id);
      }
      if (homework_activity_id) {
        return homeworkActivityService.fetch(homework_activity_id);
      }

      return of(null);
    }),
    errorHandler.catchHttpErrors(() => EMPTY),
    catchError(() => EMPTY),
    first(),
    mapToVoid(),
  );
};
